// Navbar.js

import React from 'react';
import { FaEnvelope, FaPhone, FaLinkedin, FaDownload } from 'react-icons/fa';
import '../styles/Navbar.css';
import resumePdf from '../Files/Doug Fauth Resume Stategic Innovative Leader.pdf';

const Navbar = () => {
  // Function to handle email button click
  const handleEmailClick = () => {
    window.location.href = 'mailto:dougfauth1@gmail.com';
    console.log('Email link clicked');
  };

  // Function to handle phone button click
  const handlePhoneClick = () => {
    window.location.href = 'tel:+1 (309) 258-7871';
  };

  return (
    <div className="navbar">
      <button onClick={handleEmailClick} className="link-button">
        <FaEnvelope /> &nbsp; Email Me
      </button>
      <button onClick={handlePhoneClick} className="link-button">
        <FaPhone /> &nbsp; Call Me
      </button>
      <a href="https://www.linkedin.com/in/dougfauth1/" target="_blank" rel="noopener noreferrer" className="link-button">
        <FaLinkedin /> &nbsp;LinkedIn
      </a>
      <a href={resumePdf} download="Doug_Fauth_Resume.pdf" className="download-btn">
        <FaDownload /> &nbsp;Download Resume
      </a>
    </div>
  );
};

export default Navbar;
